import { RiskRating } from 'types/riskRating';

/** Backward-compatible object alias matching the original `RiskRatings` shape. */
export const RiskRatings: Record<string, string> = {
  goodRiskScore: RiskRating.Good,
  fairRiskScore: RiskRating.Fair,
  poorRiskScore: RiskRating.Poor,
  veryPoorRiskScore: RiskRating.VeryPoor,
};

/** Array of all risk rating keys. */
export const RiskRatingKeys: string[] = Object.keys(RiskRatings);
